

































































import Vue, { PropType } from 'vue';
import SectionMenu from '@/components/SectionMenu.vue';
import SectionRowProfile from '@/components/section-row/SectionRowProfile.vue';
import SectionRowText from '@/components/section-row/SectionRowText.vue';
import SectionRowDate from '@/components/section-row/SectionRowDate.vue';
import SectionRowSkill from '@/components/section-row/SectionRowSkill.vue';
import SectionRowLink from '@/components/section-row/SectionRowLink.vue';
import SectionRowGallery from '@/components/section-row/SectionRowGallery.vue';
import {
  CvCvSectionCvSectionTypeEnum,
  CvSectionDateItem,
  CvSectionGalleryItem,
  CvSectionLinkItem,
  CvSectionProfile,
  CvSectionSkillItem,
  UpdateCvCvSectionsRequestDirectionEnum,
} from '@/../gen';

import * as CvStore from '@/containers/cv/store';
import { i18n, i18nHints } from '@/plugins/i18n';

export default Vue.extend({
  components: {
    SectionMenu,
    SectionRowProfile,
    SectionRowText,
    SectionRowDate,
    SectionRowSkill,
    SectionRowLink,
    SectionRowGallery,
  },
  props: {
    cvId: {
      type: [String, Number],
      required: true,
    },
    cvSectionProfile: {
      type: Object as PropType<CvSectionProfile>,
      required: true,
    },
    cvCvSections: {
      type: Array as () => CvStore.CvCvSectionWithSection[],
      required: true,
    },
  },
  computed: {
    CvSectionTypes: () => CvCvSectionCvSectionTypeEnum,
  },
  methods: {
    async sortUpHandler(cv_cv_section_id: number) {
      await this.$store.dispatch(
        CvStore.UpdateCvCvSections.namespaced({
          cv_id: this.cvId,
          cv_cv_section_id,
          body: {
            direction: UpdateCvCvSectionsRequestDirectionEnum.Backward,
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.updated));
    },
    async sortDownHandler(cv_cv_section_id: number) {
      await this.$store.dispatch(
        CvStore.UpdateCvCvSections.namespaced({
          cv_id: this.cvId,
          cv_cv_section_id,
          body: {
            direction: UpdateCvCvSectionsRequestDirectionEnum.Forward,
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.updated));
    },
    isAbleToUp(index: number) {
      return index !== 0;
    },
    isAbleToDown(index: number) {
      return index < this.cvCvSections.length - 1;
    },
    async refreshCvCvSections() {
      await this.$store.dispatch(
        CvStore.GetCvCvSections.namespaced({ cv_id: this.cvId })
      );
    },
    async onSortedDateItems(cvSectionItem: CvSectionDateItem, moveTo: number) {
      await this.$store.dispatch(
        CvStore.UpdateCvSectionDateItemOrder.namespaced({
          cv_id: this.cvId,
          cv_section_id: cvSectionItem.cv_section_date_id,
          cv_section_item_id: cvSectionItem.id,
          body: {
            position: moveTo,
          },
        })
      );
      await this.refreshCvCvSections();
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.updated));
    },
    async onSortedSkillItems(
      cvSectionItem: CvSectionSkillItem,
      moveTo: number
    ) {
      await this.$store.dispatch(
        CvStore.UpdateCvSectionSkillItemOrder.namespaced({
          cv_id: this.cvId,
          cv_section_id: cvSectionItem.cv_section_skill_id,
          cv_section_item_id: cvSectionItem.id,
          body: {
            position: moveTo,
          },
        })
      );
      await this.refreshCvCvSections();
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.updated));
    },
    async onSortedLinkItems(cvSectionItem: CvSectionLinkItem, moveTo: number) {
      await this.$store.dispatch(
        CvStore.UpdateCvSectionLinkItemOrder.namespaced({
          cv_id: this.cvId,
          cv_section_id: cvSectionItem.cv_section_link_id,
          cv_section_item_id: cvSectionItem.id,
          body: {
            position: moveTo,
          },
        })
      );
      await this.refreshCvCvSections();
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.updated));
    },
    async onSortedGalleryItems(
      cvSectionItem: CvSectionGalleryItem,
      moveTo: number
    ) {
      await this.$store.dispatch(
        CvStore.UpdateCvSectionGalleryItemOrder.namespaced({
          cv_id: this.cvId,
          cv_section_id: cvSectionItem.cv_section_gallery_id,
          cv_section_item_id: cvSectionItem.id,
          body: {
            position: moveTo,
          },
        })
      );
      await this.refreshCvCvSections();
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.updated));
    },
  },
});
